import * as React from 'react';
import { FormField, RadioButtonGroup } from '@cian/ui-kit';
import { EFieldSubType } from '../../constants';
import { useFormField } from '../../utils/hooks';
/**
 * Группа радио-инпутов в виде кнопок.
 */

import { jsx as _jsx } from "react/jsx-runtime";
export var RadioButtonGroupContainer = function RadioButtonGroupContainer(props) {
  var _useFormField = useFormField({
    name: props.name
  }),
      _useFormField$field = _useFormField.field,
      value = _useFormField$field.value,
      name = _useFormField$field.name,
      _useFormField$helpers = _useFormField.helpers,
      setValue = _useFormField$helpers.setValue,
      setTouched = _useFormField$helpers.setTouched,
      _useFormField$meta = _useFormField.meta,
      touched = _useFormField$meta.touched,
      error = _useFormField$meta.error;

  var handleChange = function handleChange(e, newValue) {
    setValue(newValue, true);
    setTouched(true);
  };

  if (!props.answers) {
    return null;
  }

  return /*#__PURE__*/_jsx(FormField, {
    label: props.label,
    errorMessage: touched ? error : null,
    withoutMargin: true,
    children: /*#__PURE__*/_jsx(RadioButtonGroup, {
      name: name,
      spliced: props.subType === EFieldSubType.RadioButtonGroupSpliced,
      options: props.answers,
      value: value,
      onChange: handleChange
    })
  });
};
RadioButtonGroupContainer.displayName = 'RadioButtonGroupContainer';